import "../styles/css/request-estimate.css"
import {useState} from "react";
const NoEstimateRequestAvailablePage: React.FC = () => {
    return (
        <div className='request-body'>
            <div className="container estimate-container">
                <div className="page-card estimate-thanks">
                    <i className="fas fa-thumbs-up thanks-icon"></i>
                    <h1>Thanks!</h1>
                    <p>No estimate is ready to be scheduled at this time. Please contact Barreca if you have any questions.</p>
                    <p>(847) 970-5900<br /><a href="mailto:barrecablacktop@gmail.com">barrecablacktop@gmail.com</a></p>
                </div>
            </div>
        </div>
    )
}
export default NoEstimateRequestAvailablePage;